// extracted by mini-css-extract-plugin
export default {"closer":"ZvlZO","content":"QCX0q","description":"abHfI","skeleton-progress":"UF6X5"};